"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _axios = _interopRequireDefault(require("axios"));

var _validateFetchResponse = require("../../../helpers/validateFetchResponse");

var _style = require("./style");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var airlineS3 = 'https://s3.eu-west-2.amazonaws.com/statics-bob/airlines.json';
var endpointAirline = '/company/airline';
var endpointAirport = '/airports';
var errors = {
  noResults: 'No results from server.',
  invalidResponse: 'Invalid response from server.'
};

var returnIataCode = function returnIataCode(input) {
  if (input) {
    var regExp = /\(([^)]+)\)/;
    var value = regExp.exec(input)[0];
    return value.substring(1, value.length - 1);
  }

  return false;
};

var returnAirlineName = function returnAirlineName(input) {
  if (input) {
    return input.replace(/ *\([^)]*\) */g, '');
  }

  return false;
};

var locale = {
  es: {
    airlineLabel: 'Viajo con',
    fromLabel: 'Viajo desde',
    required: 'Obligatorio',
    sameAirport: 'Los aeropuertos no pueden ser iguales',
    submitLabel: 'Empezar',
    title: '¿Cómo viajas?',
    toLabel: 'Viajo a'
  },
  en: {
    airlineLabel: 'I travel with',
    fromLabel: 'I travel from',
    required: 'Required',
    sameAirport: "Airports can't be the same",
    submitLabel: 'Get Started',
    title: 'How do you travel?',
    toLabel: 'I travel to'
  }
};

var TravelWidget = function (_PureComponent) {
  (0, _inherits2["default"])(TravelWidget, _PureComponent);

  var _super = _createSuper(TravelWidget);

  function TravelWidget(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, TravelWidget);
    _this = _super.call(this, props);

    _this.handleClick = function () {
      var _this$props = _this.props,
          language = _this$props.language,
          postUrl = _this$props.postUrl;
      var from = returnIataCode(document.getElementById('widget-from').value);
      var to = returnIataCode(document.getElementById('widget-to').value);
      var iata = returnIataCode(document.getElementById('widget-airline').value);
      var airline = returnAirlineName(document.getElementById('widget-airline').value);
      var url = new URL(window.location);
      var typeCheckin = url.searchParams.get('type_checkin');

      if (from && to && airline && from !== to) {
        window.location = "".concat(postUrl, "?from=").concat(from, "&to=").concat(to, "&airline=").concat(airline, "&marketer=").concat(iata, "&affiliate=BOB&lang=").concat(language || 'en').concat(typeCheckin ? "&type_checkin=".concat(typeCheckin) : '');
      } else {
        var sameAirport = from === to && locale[language].sameAirport;

        _this.setState({
          errorFrom: !from && locale[language].required,
          errorTo: to ? sameAirport : locale[language].required,
          errorAirline: !airline && locale[language].required
        });
      }
    };

    _this.fetch = function () {
      var _ref = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee(endpoint) {
        var instance, response, _response$data, code, data;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                instance = _this.state.instance;
                _context.next = 3;
                return instance.get(endpoint);

              case 3:
                response = _context.sent;
                _response$data = response.data, code = _response$data.code, data = _response$data.data;

                if ((0, _validateFetchResponse.isValidResponse)(code, data)) {
                  _context.next = 7;
                  break;
                }

                throw new Error(errors.invalidResponse);

              case 7:
                return _context.abrupt("return", data);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.fetchFromS3 = function () {
      var _ref2 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee2(endpoint) {
        var instance, _yield$instance$get, data;

        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                instance = _this.state.instance;
                _context2.next = 3;
                return instance.get(endpoint);

              case 3:
                _yield$instance$get = _context2.sent;
                data = _yield$instance$get.data;
                return _context2.abrupt("return", data);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.fetchFeaturedAirlines = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee3() {
      var fetchUrl, _yield$Promise$all, _yield$Promise$all2, _yield$Promise$all2$, results, _yield$Promise$all2$2, airlinesJson;

      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              fetchUrl = _this.props.fetchUrl;
              _context3.next = 4;
              return Promise.all([_this.fetch("".concat(fetchUrl).concat(endpointAirline)), _this.fetchFromS3(airlineS3)]);

            case 4:
              _yield$Promise$all = _context3.sent;
              _yield$Promise$all2 = (0, _slicedToArray2["default"])(_yield$Promise$all, 2);
              _yield$Promise$all2$ = _yield$Promise$all2[0];
              results = _yield$Promise$all2$ === void 0 ? [] : _yield$Promise$all2$;
              _yield$Promise$all2$2 = _yield$Promise$all2[1];
              airlinesJson = _yield$Promise$all2$2 === void 0 ? [] : _yield$Promise$all2$2;
              results.forEach(function (result) {
                result.title = "".concat(result.name, " (").concat(result.code, ")");
                result.value = "".concat(result.name, " (").concat(result.code, ")");
                result.featured = true;
              });
              return _context3.abrupt("return", results.concat(airlinesJson));

            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](0);
              console.error('[error] ', _context3.t0.message);
              return _context3.abrupt("return", false);

            case 18:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 14]]);
    }));

    _this.fetchFeaturedAirports = function () {
      var _ref4 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee4(language) {
        var fetchUrl, results;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                fetchUrl = _this.props.fetchUrl;
                _context4.next = 4;
                return _this.fetch("".concat(fetchUrl).concat(endpointAirport, "?locale=").concat(language));

              case 4:
                results = _context4.sent;
                return _context4.abrupt("return", results.map(function (airport) {
                  var title = "".concat(airport.name, " (").concat(airport.code, ")");
                  return {
                    title: title,
                    value: title,
                    featured: airport.featured
                  };
                }));

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](0);
                console.error('[error] ', _context4.t0.message);
                return _context4.abrupt("return", false);

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 8]]);
      }));

      return function (_x3) {
        return _ref4.apply(this, arguments);
      };
    }();

    _this.state = {
      instance: _axios["default"].create({
        timeout: 5000
      }),
      airports: [],
      airlines: [],
      errorFrom: '',
      errorTo: '',
      errorAirline: ''
    };
    return _this;
  }

  (0, _createClass2["default"])(TravelWidget, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee5() {
        var language, airlines, airports;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                language = this.props.language;
                _context5.next = 3;
                return this.fetchFeaturedAirlines();

              case 3:
                _context5.t0 = _context5.sent;

                if (_context5.t0) {
                  _context5.next = 6;
                  break;
                }

                _context5.t0 = [];

              case 6:
                airlines = _context5.t0;
                _context5.next = 9;
                return this.fetchFeaturedAirports(language);

              case 9:
                _context5.t1 = _context5.sent;

                if (_context5.t1) {
                  _context5.next = 12;
                  break;
                }

                _context5.t1 = [];

              case 12:
                airports = _context5.t1;
                this.setState({
                  airlines: airlines,
                  airports: airports
                });

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          color = _this$props2.color,
          language = _this$props2.language;
      var _this$state = this.state,
          airlines = _this$state.airlines,
          airports = _this$state.airports,
          errorAirline = _this$state.errorAirline,
          errorFrom = _this$state.errorFrom,
          errorTo = _this$state.errorTo;
      return _react["default"].createElement(_style.Widget, null, _react["default"].createElement(_style.Title, {
        color: color
      }, locale[language].title), _react["default"].createElement(_style.InputSelectContainer, {
        error: !!errorFrom
      }, _react["default"].createElement(_style.InputSelect, {
        error: !!errorFrom,
        helper: errorFrom,
        id: "widget-from",
        label: locale[language].fromLabel,
        options: airports
      })), _react["default"].createElement(_style.InputSelectContainer, {
        error: !!errorTo
      }, _react["default"].createElement(_style.InputSelect, {
        error: !!errorTo,
        helper: errorTo,
        id: "widget-to",
        label: locale[language].toLabel,
        options: airports
      })), _react["default"].createElement(_style.InputSelectContainer, {
        error: !!errorAirline
      }, _react["default"].createElement(_style.InputSelect, {
        error: !!errorAirline,
        helper: errorAirline,
        id: "widget-airline",
        label: locale[language].airlineLabel,
        options: airlines
      })), _react["default"].createElement(_style.ButtonStyled, {
        text: locale[language].submitLabel,
        handleClick: this.handleClick,
        id: "bob-widget-submit",
        name: "bob-widget-submit"
      }));
    }
  }]);
  return TravelWidget;
}(_react.PureComponent);

TravelWidget.propTypes = {
  color: _propTypes["default"].string,
  fetchUrl: _propTypes["default"].string,
  language: _propTypes["default"].string,
  postUrl: _propTypes["default"].string
};
TravelWidget.defaultProps = {
  color: '',
  fetchUrl: '',
  language: 'en',
  postUrl: ''
};
var _default = TravelWidget;
exports["default"] = _default;